import { Injectable } from '@angular/core';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';
import { ToastService } from './toast.service';
import { DateRange } from '../models/dateRange.model';

@Injectable()
export class TimeZoneService {
    constructor(private toastService: ToastService) { }

    createTimeZoneLabel(timeZone: string) {
        try {
            if (timeZone) {
                const utcOffset = formatInTimeZone(new Date(), timeZone, 'xxx');
                return `${timeZone} (UTC ${utcOffset})`;
            }
        } catch (error) {
        }

        return 'UTC (UTC +00:00)';
    }

    createDateRange(option: string, timeZone: string): DateRange {
        let endDate: Date;
        try {
            endDate = toZonedTime(new Date(), timeZone);
        } catch (error) {
            this.toastService.displayErrorMessage("Invalid time zone: {{timeZone}}", true, { timeZone: timeZone });
            return null;
        }

        const startDate = new Date(endDate.getTime());

        switch (option) {
            case '8h':
                startDate.setHours(startDate.getHours() - 8);
                break;
            case '3d':
                startDate.setDate(startDate.getDate() - 3);
                break;
            case '1m':
                startDate.setDate(startDate.getDate() - 30);
                break;
        }

        return new DateRange(startDate, endDate);
    }

    convertTimestampToLocalDate(timestamp: number, timeZone: string) {
        return toZonedTime(new Date(timestamp), timeZone);
    }
}
